import { useQuery } from '@tanstack/react-query';
import { fetchPreClaimsTypes } from '../../data-provider/select-options';

export const useGetPreClaimsTypeList = () => {
  return useQuery({
    queryKey: ['pre-claims-type-list'],
    queryFn: () => fetchPreClaimsTypes(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
